"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconLookupFilled = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 20 20",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M2,4 L0,4 L0,20 L16,20 L16,18 L2,18 L2,4 Z M20,0 L4,0 L4,16 L20,16 L20,0 Z M17,9 L7,9 L7,7 L17,7 L17,9 Z M13,13 L7,13 L7,11 L13,11 L13,13 Z M17,5 L7,5 L7,3 L17,3 L17,5 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconLookupFilled')(IconLookupFilled);